

























import Api from "@/api/Api";
import { Advertiser } from "@/interfaces/advertiser";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    advertiser: Object as PropType<Advertiser>
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    async exec(cb: () => void) {
      if (!this.advertiser) {
        return;
      }
      await Api.singleton().call({
        method: "DELETE",
        resource: this.advertiser["@id"]
      });
      this.$emit("success");
      cb();
    }
  }
});
